export function initials(value: string | undefined): string {
  if (!value?.trim()) {
    return ''
  }

  const initials = value
    .split(' ')
    .filter(Boolean)
    .map(([firstLetter]) => firstLetter)

  if (!initials.length) {
    return ''
  }

  if (initials.length === 1) {
    return initials.toString().toUpperCase()
  }

  const [first] = initials
  const [last] = initials.slice(-1)

  return (first + last).toUpperCase()
}
